import {
    Container,
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    NavbarText,
    Row,
    Col,
    Label,
    Card,
    Button,
    CardImg,
    CardTitle,
    CardText,
    CardDeck,
    CardSubtitle,
    CardBody,
    Carousel,
    CarouselItem,
    CarouselControl,
    CarouselIndicators,
    CarouselCaption,
    TabContent,
    TabPane,
    UncontrolledTooltip
} from 'reactstrap';
import {
    BrowserView,
    MobileView,
    isDesktop,
    isMobile,
    isTablet
} from "react-device-detect";
import { Fade, Slide } from "react-reveal";
import { Fragment } from 'react';

const TechnicalAcads = ({
    handleChangeModal,
    technicalEducation
}) => {
    return (
        <Container fluid={true}>
            <Row className={isDesktop ? "align-items-center justify-content-center d-flex mb-5 ml-3" : "align-items-center justify-content-center d-flex mb-5 ml-1 mr-1"} lg="12" md="12" xs="12">
                <Col lg="7" md="7" xs="12" className="text-justify mt-5">
                    <h4 id="technicalEducationMainTitle" style={{ cursor: "pointer" }} onClick={() => handleChangeModal("Technical Education Main Title")} className={isDesktop ? "text-danger-edit font-weight-bolder" : "text-danger-edit font-weight-bolder text-center"}>{technicalEducation.mainTitle || "<no content>"}</h4>
                    <UncontrolledTooltip placement="top" target="technicalEducationMainTitle">
                        <h5>Click to Update</h5>
                    </UncontrolledTooltip>
                    <Label className="text-secondary mr-2" style={{ fontSize: "14px" }}>
                        <br />
                        <span id="technicalEducationContentTitle1" style={{ cursor: "pointer" }} onClick={() => handleChangeModal("Technical Education Content Title", "first")}>{technicalEducation.contentTitle1 || "<no content>"}</span>
                        <UncontrolledTooltip placement="top" target="technicalEducationContentTitle1">
                            <h5>Click to Update</h5>
                        </UncontrolledTooltip>

                        <ol id="technicalEducationContents1" style={{ cursor: "pointer" }} onClick={() => handleChangeModal("Technical Education Contents", "first")}>
                            {technicalEducation.contents1.length >= 1 ? technicalEducation.contents1.map((content, key) => {
                                return (
                                    <Fragment key={key}>
                                        <li>{key + 1 + ". "} {content.text}</li>
                                    </Fragment>
                                )
                            }) : <li>{"<no content>"}</li>}
                        </ol>
                        <UncontrolledTooltip placement="top" target="technicalEducationContents1">
                            <h5>Click to Update</h5>
                        </UncontrolledTooltip>
                    </Label>
                    <br />

                    <Label className="text-secondary" style={{ fontSize: "15px" }}>
                        <Row className={isDesktop ? "" : "text-left"}>
                            <Col md="6">
                                <strong id="technicalEducationContentTitle2" style={{ cursor: "pointer" }} onClick={() => handleChangeModal("Technical Education Content Title", "second")}>{technicalEducation.contentTitle2 || "<no content>"}</strong>
                                <UncontrolledTooltip placement="top" target="technicalEducationContentTitle2">
                                    <h5>Click to Update</h5>
                                </UncontrolledTooltip>
                                <br /><br />

                                <ul id="technicalEducationContents2" style={{ cursor: "pointer" }} onClick={() => handleChangeModal("Technical Education Contents", "second")}>
                                    {technicalEducation.contents2.length >= 1 ? technicalEducation.contents2.map((content, key) => {
                                        return (
                                            <Fragment key={key}>
                                                <li>{content.text}</li>
                                            </Fragment>
                                        )
                                    }) : <li>{"<no content>"}</li>}
                                </ul>
                                <UncontrolledTooltip placement="top" target="technicalEducationContents2">
                                    <h5>Click to Update</h5>
                                </UncontrolledTooltip>
                            </Col>
                            <Col md="6" className='w-75'>
                                <strong id="technicalEducationContentTitle3" style={{ cursor: "pointer" }} onClick={() => handleChangeModal("Technical Education Content Title", "third")}>{technicalEducation.contentTitle3 || "<no content>"}</strong>
                                <UncontrolledTooltip placement="top" target="technicalEducationContentTitle3">
                                    <h5>Click to Update</h5>
                                </UncontrolledTooltip>

                                <br /><br />
                                <ul id="technicalEducationContents3" style={{ cursor: "pointer" }} onClick={() => handleChangeModal("Technical Education Contents", "third")}>
                                    {technicalEducation.contents3.length >= 1 ? technicalEducation.contents3.map((content, key) => {
                                        return (
                                            <Fragment key={key}>
                                                <li>{content.text}</li>
                                            </Fragment>
                                        )
                                    }) : <li>{"<no content>"}</li>}
                                </ul>
                                <UncontrolledTooltip placement="top" target="technicalEducationContentTitle3">
                                    <h5>Click to Update</h5>
                                </UncontrolledTooltip>
                            </Col>
                        </Row>
                    </Label>
                </Col>

                <Col md="5">
                    {isDesktop ?
                        <Container className="acads-tertiary-cont">
                            <Slide right>
                                <img id="technicalEducationImage2" style={{ cursor: "pointer" }} onClick={() => handleChangeModal("Technical Education Image", "second")} src={technicalEducation.image2} style={{ cursor: "pointer", width: "500px", objectFit: "cover", height: "340px" }} className="tertiary-image back-image-tech" />
                            </Slide>
                            <UncontrolledTooltip placement="top" target="technicalEducationImage2">
                                <h5>Click to Update Image</h5>
                            </UncontrolledTooltip>
                            <Slide left>
                                <img id="technicalEducationImage1" style={{ cursor: "pointer" }} onClick={() => handleChangeModal("Technical Education Image", "first")} src={technicalEducation.image1} style={{ cursor: "pointer", width: "470px", objectFit: "cover", height: "290px" }} className="tertiary-image front-image-tech" />
                            </Slide>
                            <UncontrolledTooltip placement="top" target="technicalEducationImage1">
                                <h5>Click to Update Image</h5>
                            </UncontrolledTooltip>
                        </Container>
                        :
                        <Container>
                            <Slide right>
                                <img id="technicalEducationImage2" style={{ cursor: "pointer" }} onClick={() => handleChangeModal("Technical Education Image", "second")} src={technicalEducation.image2} style={{ cursor: "pointer", width: "500px", objectFit: "cover", height: "340px" }} className="w-100 mb-3" />
                            </Slide>
                            <UncontrolledTooltip placement="top" target="technicalEducationImage2">
                                <h5>Click to Update Image</h5>
                            </UncontrolledTooltip>
                            <Slide left>
                                <img id="technicalEducationImage1" style={{ cursor: "pointer" }} onClick={() => handleChangeModal("Technical Education Image", "first")} src={technicalEducation.image2} style={{ cursor: "pointer", width: "500px", objectFit: "cover", height: "340px" }} src={technicalEducation.image1} style={{ cursor: "pointer", width: "500px", objectFit: "cover", height: "340px" }} className="w-100" />
                            </Slide>
                            <UncontrolledTooltip placement="top" target="technicalEducationImage1">
                                <h5>Click to Update Image</h5>
                            </UncontrolledTooltip>
                        </Container>
                    }
                </Col>
            </Row>
        </Container>
    );

}

export default TechnicalAcads;
